module.exports = __webpack_public_path__ + "static/media/headerLogo.beaeadbf.png";